import * as echarts from 'echarts';
import { ChartSize } from '../interfaces/chart-data.interface';

export class ChartHelpers {
  static initChart(element: HTMLElement, size?: ChartSize): echarts.ECharts {
    const chart = echarts.init(element);

    if (size) {
      chart.resize({
        width: size.width ? Number(size.width) : undefined,
        height: size.height ? Number(size.height) : undefined,
      });
    }

    return chart;
  }

  static destroyChart(chart: echarts.ECharts | null): void {
    if (chart) {
      chart.dispose();
    }
  }

  static resizeChart(chart: echarts.ECharts | null): void {
    if (chart) {
      chart.resize();
    }
  }

  static formatPercentage(value: number): string {
    return `${value.toFixed(1)}%`;
  }

  static getResponsiveDimensions(container: HTMLElement): ChartSize {
    return {
      width: container.clientWidth,
      height: Math.max(container.clientHeight, 300),
    };
  }
}
